import React from "react";
import Vizualisation from "../../../../components/Vizualisation";
import useVizualisation from "../../../../helpers/useVizualisation";
import FadeIn from "react-fade-in";
import price from "./../../data/price.json";
import continents from "./../../data/continents.json";
import { range } from "d3-array";
import { line } from "d3-shape";
import { scaleOrdinal, scaleLinear } from "d3-scale";

const margin = {
  top: 20,
  right: 50,
  bottom: 10,
  left: 50,
};

const Price = ({
  data,
  title,
  section,
  note,
  source,
  sectionIndex,
  index = 0,
  scrollerNum = 0,
  id,
  legendLabel,
  ...rest
}) => {
  const { ref, width } = useVizualisation();

  const height = 500;

  const w = 950 - margin.left - margin.right;
  const h = height - margin.top - margin.bottom;

  const c = scaleOrdinal().range([
    "#AD5E47",
    "#31989E",
    "#3574B6",
    "#481F7C",
    "#CD546C",
  ]);

  const x = scaleLinear().domain([-180, 180]).range([0, w]);

  const y = scaleLinear()
    .domain([-90, 90])
    .range([w / 3, -w / 3]);

  const l = line()
    .x((d) => x(d[0]))
    .y((d) => y(d[1]));

  const continentData = continents.features
    .filter((d) => d.properties.CONTINENT !== "Antarctica")
    .map((feature) => feature.geometry.coordinates);

  const Continent = ({ polygons }) => {
    return (
      <g>
        {polygons
          .filter((d) => d[0].length >= 100)
          .map((polygon, i) => (
            <path key={`polygon-${i}`} d={l(polygon[0])} fill="#E5E5E5" />
          ))}
      </g>
    );
  };

  return (
    <Vizualisation note={note} source={source} ref={ref} size="large">
      <svg viewBox="0 0 950 500">
        <g transform={`translate(${margin.left}, ${margin.top})`}>
          <g transform={`translate(${0}, ${h / 2})`}>
            <FadeIn wrapperTag="g" childTag="g">
              {continentData.map((continent, i) => (
                <Continent polygons={continent} key={`continent-${i}`} />
              ))}
              {(scrollerNum === undefined || index === 0
                ? price.filter((d) =>
                    ["Europe", "North America"].includes(d.region)
                  )
                : price
              )
                .sort((a, b) => a.price - b.price)
                .map((d, i) => (
                  <g
                    transform={`translate(${x(d.lon)}, ${y(d.lat)})`}
                    key={`hub-${i}`}
                  >
                    <circle
                      stroke={c(d.region)}
                      fill="none"
                      r={Math.sqrt(d.price) * 15}
                      style={{ fillOpacity: 0.5, strokeWidth: 2 }}
                    />
                    {range(Math.ceil(Math.sqrt(1 + d.price * 15))).map((j) => (
                      <circle
                        key={`inner-circle-${j}`}
                        r={j * 4}
                        fill="none"
                        stroke={c(d.region)}
                      />
                    ))}
                  </g>
                ))}
            </FadeIn>
          </g>
          <g className="legend" transform={`translate(0, ${h - 100})`}>
            <text
              style={{
                fontSize: 12,
                fontWeight: "bold",
                textAnchor: "start",
              }}
              y={-Math.sqrt(8) * 15 * 2}
              dy={-20}
              dx={-50}
            >
              {legendLabel}
            </text>
            {[0.5, 1, 2, 4, 8].map((d, i) => (
              <g
                transform={`translate(0, ${-Math.sqrt(d) * 15})`}
                key={`legend-item-${i}`}
              >
                <circle r={Math.sqrt(d) * 15} fill="none" stroke="#8E9598" />
                <line
                  x2={100}
                  y1={-Math.sqrt(d) * 15}
                  y2={-Math.sqrt(d) * 15}
                  stroke="#CCCCCF"
                  style={{ strokeWidth: 0.7 }}
                />
                <text
                  style={{
                    fontSize: 12,
                    textAnchor: "middle",
                    dominantBaseline: "central",
                  }}
                  y={-Math.sqrt(d) * 15}
                  dy={i === 0 ? 4 : 0}
                  dx={100}
                >
                  ${d}
                </text>
              </g>
            ))}
          </g>
        </g>
      </svg>
    </Vizualisation>
  );
};

export default Price;
